import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    component: () => import('@/views/index.vue')
  },
  // {
  //   path: '/',
  //   redirect: '/uploadPictures',
  //   name: 'uploadPictures',
  //   component: () => import('@/views/index.vue'),
  //   children: [{
  //       path: '/uploadPictures',
  //       component: () => import('@/views/index.vue'),
  //     },

  //   ]
  // },
  {
    path: '/abnormalupload',
    name: 'abnormalupload',
    component: () => import('@/views/abnormalupload.vue'),

  },
   {
    path: '/qualityinspectionabnorm',
    name: 'qualityinspectionabnorm',
    component: () => import('@/views/qualityinspectionabnorm.vue'),

  },
  {
    path: '/uploadhandovervoucher',
    name: 'uploadhandovervoucher',
    component: () => import('@/views/uploadhandovervoucher.vue'),

  },

  {
    path: '/finish',
    component: () => import('@/views/finish.vue'),
  },
  {
    path: '/sixFaceImage',
    component: () => import('@/views/uploadSixImage.vue'),
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router